import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import smartParkService from "../../axios";
import { KeyboardBackspace, LocalDrinkSharp } from "@material-ui/icons";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import styles from "../../components/components.js";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { login_, token_ } from "../../reducers/login";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { processInputs } from "../../utils/processInput.js";
const helperTextStyles = makeStyles((theme) => ({
  root: {
    margin: 4,
    color: "red",
  },
  error: {
    "&.MuiFormHelperText-root.Mui-error": {
      color: theme.palette.common.white,
    },
  },
}));
const useStyles = makeStyles(styles);

export default function Dashboard() {
  const location = useLocation();
  const helperTestClasses = helperTextStyles();
  const loginDetails = useSelector(login_);
  const parkid = _.get(loginDetails, ["parkID"], "");
  const token = useSelector(token_);
  smartParkService.defaults.headers.common["x-access-token"] = token;
  const name = _.get(loginDetails, ["FirstName"], "");
  const userid = _.get(loginDetails, ["UserID"], "");
  const classes = useStyles();
  const history = useHistory();
  const [featureName, setfeatureName] = useState("");
  const [featureDesc, setfeatureDesc] = useState("");
  const [existingFeatures, setExistingFeatures] = useState([]);
  const [featureErrorMessage, setFeatureErrorMessage] = useState("");
  const [descriptionErrorMessage, setDescriptionErrorMessage] = useState("");

  const existingName = (featureName) => {
    const processedName = featureName.trim().replace(/\s+/g, " ").toLowerCase();
    setfeatureName(processedName);

    return existingFeatures.some(
      (feature) =>
        feature.name && feature.name.trim("").toLowerCase() === processedName
    );
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/AccessManagment");
    } else {
      setExistingFeatures(location?.state?.data);
    }
  }, [location]);

  const saveFeature = () => {
    let error = false;
    if (featureName.trim("") === "") {
      setfeatureName("");
      setFeatureErrorMessage("Please enter a valid name.");
      error = true;
    }
    if (!featureName) {
      setFeatureErrorMessage("Please enter feature name.");
      error = true;
    }

    if (existingName(featureName)) {
      setFeatureErrorMessage("Feature name already exists.");
      error = true;
    }
    if (!featureDesc) {
      setDescriptionErrorMessage("Please enter feature description.");
      error = true;
    }
    if (featureDesc.trim() === "") {
      setDescriptionErrorMessage("Please enter valid description.");
      setfeatureDesc("");
      error = true;
    }
    if (!error) {
      var featureobject = {};
      featureobject.FeatureName = processInputs(featureName);
      featureobject.Featuredescription = processInputs(featureDesc);
      featureobject.parkID = parkid;
      //    featureobject.InsertedBy= JSON.parse(localStorage.getItem('user')).name;
      featureobject.InsertedBy = name;
      smartParkService
        .post("api/park/" + parkid + "/features", featureobject, {
          headers: {
            userid: userid,
          },
        })
        .then(async (res, err) => {
          if (res.data.status === "200") {
            await updaterolefeature(res.data.data);
            history.push("/AccessManagment");
          } else {
            alert("User Data Invalid");
          }
        })
        .catch((error) => {
          alert(error);
        });
    }
  };
  const updaterolefeature = (data) => {
    const featureobject = {};
    featureobject.RolePermission = {
      featureID: data.FeatureID,
      feature: data.FeatureName,
      create: "0",
      read: "0",
      update: "0",
      delete: "0",
    };
    smartParkService
      .post("api/park/" + parkid + "/rolepermissionsfeature", featureobject, {
        headers: {
          userid: userid,
        },
      })
      .then((res, err) => {
        if (res) {
          alert("Feature updated");
          history.push("/AccessManagment");
        } else {
        }
      })
      .catch((error) => {
        alert(error);
      });
  };
  return (
    <div className={classes.root}>
      <div className={classes.contentPage}>
        <section class="content-header">
          <h3 class="float-left">Access Management</h3>
          <div class="float-right">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a class="active" href="#">
                  Access Management
                </a>
              </li>
            </ol>
          </div>
        </section>
        <section class="content">
          <div class="content-middle">
            <div class="content-sub-header">
              <div>
                <Link
                  component="button"
                  onClick={() => history.push("./AccessManagment")}
                >
                  {" "}
                  <KeyboardBackspace style={{ fontSize: 18 }} /> &nbsp; Back
                </Link>
              </div>
              <div>
                <h3>Add Feature</h3>
              </div>
              <div class="display-xs-0">
                <Link
                  style={{ visibility: "hidden" }}
                  component="button"
                  onClick={() => history.push("/AccessManagement")}
                >
                  {" "}
                  <KeyboardBackspace style={{ fontSize: 18 }} /> &nbsp; Back
                </Link>
              </div>
            </div>

            <Paper className={classes.paper}>
              <div class="form-body pad20">
                <Grid container spacing={3} className={classes.pad20}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      size="small"
                      required
                      id="featureName"
                      name="featureName"
                      value={featureName}
                      helperText={featureErrorMessage}
                      FormHelperTextProps={{ classes: helperTestClasses }}
                      label="Feature Name"
                      onChange={(e) => {
                        setfeatureName(e.target.value);
                      }}
                      onClick={() => {
                        setFeatureErrorMessage("");
                      }}
                      onBlur={() => {
                        if (!featureName) {
                          setFeatureErrorMessage("Please enter feature name.");
                        }
                      }}
                      autoComplete="Feature-name"
                      className={classes.w80p}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      size="small"
                      id="Description"
                      label="Description"
                      multiline
                      rows={4}
                      value={featureDesc}
                      onChange={(e) => {
                        setfeatureDesc(e.target.value);
                      }}
                      onClick={() => {
                        setDescriptionErrorMessage("");
                      }}
                      onBlur={() => {
                        if (!featureDesc) {
                          setDescriptionErrorMessage(
                            "Please enter feature description."
                          );
                        }
                      }}
                      helperText={descriptionErrorMessage}
                      FormHelperTextProps={{ classes: helperTestClasses }}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </div>
              <div class="form-footer">
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  className={classes.btnRound}
                  onClick={saveFeature}
                >
                  SAVE
                </Button>
                &nbsp;&nbsp;
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  className={classes.btnRound}
                >
                  CANCEL
                </Button>
              </div>
            </Paper>
          </div>
        </section>
      </div>
    </div>
  );
}
